import { gql, MutationHookOptions, useMutation } from '@apollo/client';
import { SendOtpMutationArgs } from '../../dto';

type Results = boolean;
type Variables = SendOtpMutationArgs;

export const useSendOtp = (options?: MutationHookOptions<Results, Variables>) => {
  const mutation = gql`
    mutation sendOtp($method: String!) {
      sendOtp(method: $method)
    }
  `;

  return useMutation(mutation);
};

export default useSendOtp;
